import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id in URL');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for user session
        const response = await googleLogin(sessionId);
        
        // Redirect based on role
        if (response.user.role === 'admin') {
          navigate('/admin', { replace: true, state: { user: response.user } });
        } else {
          navigate('/', { replace: true, state: { user: response.user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true, state: { error: 'Authentication failed' } });
      }
    };

    processAuth();
  }, [location.hash, googleLogin, navigate]);

  return (
    <div className="min-h-screen bg-ivory-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-gold-600 animate-spin mx-auto mb-4" />
        <p className="text-ivory-600 font-body">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
